import type { FileUploadFragment } from "@qw/graphql";
import type { FC } from "react";

import { formatFileSize, parseFilename } from "../../utils/files";
import { Button } from "../button";
import { FilePreviewDialog } from "../file-preview-dialog";
import { useFilePreviewDialog } from "../use-file-preview-dialog";

export interface MessageAttachmentsProps {
  files: FileUploadFragment[];
}

export const MessageAttachments: FC<MessageAttachmentsProps> = ({ files }) => {
  const filePreview = useFilePreviewDialog({ files });

  return (
    <>
      <div className="@container grid grid-cols-1 @xl:grid-cols-2 @4xl:grid-cols-3 gap-3 mx-(--gutter) mb-6">
        {files.map((file) => (
          <MessageAttachment key={file.id} file={file} openFile={filePreview.openFile} />
        ))}
      </div>
      <FilePreviewDialog {...filePreview.dialogProps} />
    </>
  );
};

const MessageAttachment = ({
  file,
  openFile,
}: {
  file: FileUploadFragment;
  openFile: (file: FileUploadFragment) => void;
}) => {
  const { filename, mimeType, size } = file;
  const { name, extension } = parseFilename(filename);

  return (
    <Button
      variant="outline"
      size="sm"
      title={`${filename} ${mimeType}`}
      onClick={() => openFile(file)}
      className="pl-1 pr-2"
    >
      <span className="flex-none inline-flex h-6 items-center justify-center w-8 text-muted-foreground rounded-xs truncate uppercase">
        {extension || "???"}
      </span>
      <span className="flex-auto font-medium text-xs text-left truncate">{name}</span>
      <span className="flex-none text-2xs text-muted-foreground">{formatFileSize(size)}</span>
    </Button>
  );
};
